var _BreadcrumbDivider;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from 'react';
import { any, array, bool } from 'prop-types';
import clsx from 'clsx';
import { styled } from '@mui/material/styles';
import SovosLink from '../../sovos-link/SovosLink';
const BreadcrumbList = styled('ol')({
  margin: 0,
  padding: 0,
  listStyle: 'none',
  whiteSpace: 'nowrap'
});
const Breadcrumb = styled('li')(_ref => {
  let {
    theme: {
      typography
    }
  } = _ref;
  return {
    ...typography.body1,
    display: 'inline',
    margin: 0,
    padding: 0
  };
});
const BreadcrumbText = styled(SovosLink)(_ref2 => {
  let {
    theme: {
      palette,
      transitions
    }
  } = _ref2;
  return {
    color: palette.primary,
    outline: 'none',
    transition: "color ".concat(transitions.duration.complex, "ms"),
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline'
    }
  };
});
const BreadcrumbDivider = styled('span')(_ref3 => {
  let {
    theme: {
      spacing
    }
  } = _ref3;
  return {
    padding: "0 ".concat(spacing(0.75))
  };
});
export const abbreviatedText = '…';
export const BreadcrumbsWithoutRef = _ref4 => {
  let {
    ancestorsCollapsed,
    forwardedRef,
    pageCrumbs,
    parentCollapsed
  } = _ref4;
  const renderBreadcrumb = (item, isCollapsed) => /*#__PURE__*/React.createElement(BreadcrumbText, {
    onClick: item.onClick,
    className: clsx('sovosPageTitleBar__breadCrumbText', !!item.onClick && 'sovosPageTitleBar__breadCrumbText--clickable'),
    tabIndex: 0,
    role: "button",
    title: isCollapsed && item.text
  }, isCollapsed ? abbreviatedText : item.text);
  return /*#__PURE__*/React.createElement("nav", {
    ref: forwardedRef,
    className: "sovosPageTitleBar__breadcrumbsContainer",
    "aria-label": "breadcrumb"
  }, /*#__PURE__*/React.createElement(BreadcrumbList, null, pageCrumbs === null || pageCrumbs === void 0 ? void 0 : pageCrumbs.map((element, index) => {
    const isLastItem = index === pageCrumbs.length - 1;
    const isCollapsed = parentCollapsed || !isLastItem && ancestorsCollapsed;
    return /*#__PURE__*/React.createElement(Breadcrumb, {
      className: "sovosPageTitleBar__breadCrumb",
      key: "BreadCrumb-".concat(element.text)
    }, renderBreadcrumb(element, isCollapsed), !isLastItem && (_BreadcrumbDivider || (_BreadcrumbDivider = /*#__PURE__*/React.createElement(BreadcrumbDivider, {
      "aria-hidden": "true"
    }, "/"))));
  })));
};
BreadcrumbsWithoutRef.propTypes = {
  ancestorsCollapsed: bool.isRequired,
  forwardedRef: any.isRequired,
  pageCrumbs: array.isRequired,
  parentCollapsed: bool.isRequired
};
export default /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(BreadcrumbsWithoutRef, _extends({}, props, {
  forwardedRef: ref
})));